import { __awaiter } from "tslib";
import { buildModuleProps } from 'pathfinder/rules-engine/moduleProps';
export const getGameFAQsGuidesv2ModuleMethods = (moduleConfig) => __awaiter(void 0, void 0, void 0, function* () {
    const moduleProps = buildModuleProps(moduleConfig, {});
    const { log } = moduleProps;
    try {
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        const render = () => { };
        return {
            render,
        };
    }
    catch (error) {
        log.debug('GameFAQS guides v2 experiment error', error);
    }
    // something went wrong - return null
    return null;
});
